import { render, staticRenderFns } from "./UserInterest.vue?vue&type=template&id=0cf0bb55&"
import script from "./UserInterest.vue?vue&type=script&lang=js&"
export * from "./UserInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports